











































































































import { Component } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption,
} from '@/components/CustomSelect/CustomSelectModel';
import RowsTable from '@/components/Table/RowsTable.vue';
import AdminService from '@/api/AdminService';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import TextInput from '@/components/TextInput/TextInput.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import eventBus from '@/utils/eventBus';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { EBusinessStatus } from '@/models/business';
import DateUtils from '@/utils/DateUtils';
import { getBusinessLocationInfo } from '../../../utils/businessLocationHelper';
import flagKeys from '@/constants/flagKeys';
import ImageUploadService from '@/api/ImageUploadService';

const SEARCHABLE_FIELDS = 'searchableFields=business.name';

@Component({
  components: {
    Table,
    RowsTable,
    ContextMenu,
    TextInput,
    CustomSelect,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
  },
})
export default class BusinessList extends BasePagination {
  limit = 20;
  service: AdminService = new AdminService();
  businessList: List = new List([], []);
  fidelNullLabel = 'Pending';
  searchableFields = SEARCHABLE_FIELDS;
  sortField = 'business.name';
  sortOrder = 'ASC';
  filterValuesSeparator = ':';
  imageUploadService = new ImageUploadService();

  // `?search=` must be in the query before BasePagination's created() fires the
  // first load; applying it later races that unfiltered request.
  data() {
    const { search } = this.$route.query;
    if (typeof search !== 'string' || !search) return {};

    return {
      search,
      query: `&${SEARCHABLE_FIELDS}&search=${encodeURIComponent(search)}`,
      listFiltersSelecteds: { status: [], title: [search] }
    };
  }

  created() {
    eventBus.$on('reloadBusinessList', () => this.reloadList(true, true));
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get merchantDashboardReportsIsActive() {
    return this.flags.includes(flagKeys.merchantDashboardReports);
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('active', `Active`),
      new CustomSelectOption('inactive', `Inactive`),
      new CustomSelectOption('hiddenOnApp', 'Hidden on App'),
      new CustomSelectOption('visibleOnApp', 'Visible on App'),
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Filter by status`,
      false,
      true,
      true,
      false,
    );
  }

  getClassNameByBusiness(business: any) {
    if (business.status === EBusinessStatus.hidden) {
      return '--hidden';
    }

    return false;
  }

  getOptionsByData(business: any) {
    const options: ContextMenuOption[] = [
      {
        label: 'Impersonate',
        action: 'impersonate',
      },
      {
        label: business.shouldHideForCustomer
          ? 'Shown on App'
          : 'Hidden on App',
        action: business.shouldHideForCustomer ? 'showOnApp' : 'hideOnApp',
      },
    ];

    Object.keys(EBusinessStatus).forEach((key) => {
      const statusesObj = EBusinessStatus as any;
      const item = statusesObj[key];
      if (item === EBusinessStatus.unknown) return;

      if (business.status !== item) {
        options.push({
          label: `Set as ${item}`,
          action: 'setStatus',
          props: [item],
        });
      }
    });

    if (business.fidel === this.fidelNullLabel) {
      options.push({
        label: 'Send to Fidel',
        action: 'connectFidel',
      });
    } else {
      options.push({
        label: 'Force Update to Fidel',
        action: 'connectFidel',
      });
    }

    options.push({
      label: 'Upload Cover Cap',
      action: 'uploadCoverCap',
    });

    return options;
  }

  async handleShowOrHideOnApp({
    businessId,
    shouldHideForCustomer,
  }: {
    businessId: string;
    shouldHideForCustomer: boolean;
  }) {
    try {
      this.$showLoaderWithLocker();

      await this.service.setBusinessHideOnApp(
        businessId,
        shouldHideForCustomer,
      );

      this.businessList.list = this.businessList.list.map((item) => {
        if (item.id === businessId) {
          return {
            ...item,
            shouldHideForCustomer,
          };
        }

        return item;
      });
    } finally {
      this.$hideLoader();
    }
  }

  optionSelected(action: string, props: Array<any>, business: any): void {
    switch (action) {
      case 'impersonate':
        this.impersonate(business);
        break;
      case 'hideOnApp':
        this.handleShowOrHideOnApp({
          businessId: business.id,
          shouldHideForCustomer: true,
        });
        break;
      case 'showOnApp':
        this.handleShowOrHideOnApp({
          businessId: business.id,
          shouldHideForCustomer: false,
        });
        break;
      case 'setStatus':
        this.setStatus(props[0], business);
        break;
      case 'connectFidel':
        this.connectFidel(business);
        break;
      case 'uploadCoverCap':
        this.uploadCoverCap(business);
        break;
      default:
        break;
    }
  }

  initHeader() {
    const header = [
      new HeaderList(`Business`, 'none', '12px'),
      new HeaderList(`Business name`, 'business.name'),
      new HeaderList(`Business Location`, 'business.city'),
      new HeaderList(`MID`, 'business.merchantId', '12px'),
      new HeaderList(`Has Stripe`, 'none', '12px'),
      new HeaderList(`New Customers`, 'newCustomers', '12px'),
      new HeaderList(`Status`, 'business.status', '12px'),
      new HeaderList(
        'Visible on App',
        'business.shouldHideForCustomer',
        '12px',
      ),
      new HeaderList(`Created At`, 'business.createdAt', '12px'),
      new HeaderList(`Fidel Status`, 'business_fidel.status', '12px'),
      new HeaderList(``, 'none', '36px'),
    ];
    this.businessList.header = header;
  }

  openAddMID(data: any) {
    const modalConfig = {
      isOpen: true,
      component: 'addMerchantId',
      data,
    };

    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  connectFidel(business: any) {
    this.$showLoaderWithLocker();
    this.service.connectFidel(business.id).then((res) => {
      this.$hideLoader();
      if (res.status === 200) {
        this.$notification('Business info sent to Fidel successfully');
        this.reloadList(true, true, undefined, true);
      }
    });
  }

  setStatus(status: any, business: any) {
    this.$showLoaderWithLocker();
    this.service
      .setBusinessStatus(business.id, { status: status.toLowerCase() })
      .then((res) => {
        this.$hideLoader();
        if (res.status === 200) {
          this.$notification(`Business set as ${status} succesfully`);
          this.reloadList(true, true, undefined, true);
        }
      });
  }

  impersonate(business: any) {
    this.service
      .impersonate({
        mail: business.mail,
        business: business.id,
      })
      .then((res) => {
        const { access_token } = res.data;
        this.service.setCredentials(access_token, true);

        (window.top || window).location.assign('/home');
      });
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    notEmpty?: boolean,
  ) {
    if (clearList) {
      this.resetPagination();
      if (!notEmpty) this.businessList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;
    this.service
      .getBusinessesList({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query,
      })
      .then((response) => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = decodeURIComponent(links.next);
          if (!links.next) this.maxItems = true;
          this.businessList.list = this.addRowsToList(items);
        } else {
          // refresh page and add items
          this.businessList.list = this.businessList.list.concat(
            this.addRowsToList(items),
          );
          if (!links.next) this.maxItems = true;
          this.pagination = decodeURIComponent(links.next);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (this.hasLoadedMore && notEmpty) {
          const listElement = this.$refs.list as HTMLElement;
          listElement.scrollTo(0, 0);
          this.hasLoadedMore = false;
        }

        this.$hideLoader();
        this.isLoading = true;
        this.refreshing = false;
      });
  }

  getStatus(status: string) {
    if (status === 'active' || status === 'launch-campaign-active') {
      return EBusinessStatus.active;
    }

    if (status === 'inactive' || status === 'launch-campaign-inactive') {
      return EBusinessStatus.inactive;
    }

    if (status === 'hidden') {
      return EBusinessStatus.hidden;
    }

    return EBusinessStatus.unknown;
  }

  getFidel(fidelStatus: string) {
    if (fidelStatus === null) return this.fidelNullLabel;

    if (fidelStatus === 'Active') return 'Connected';

    if (fidelStatus === 'Requested') return 'Sent';

    return fidelStatus;
  }

  addRowsToList(businessRows: any[]): any[] {
    return businessRows.map((business: any) => ({
      id: business.id,
      picture: business.logo.publicPath.small,
      name: business.name,
      mail: business.manager.mail,
      managerName: business.manager.fullName,
      phone: business.phone,
      address: getBusinessLocationInfo(business),
      merchantId: business.merchantId,
      step1: business.step >= 1,
      step2: business.step >= 2,
      step3: business.step >= 3,
      newCustomers: business.newCustomers,
      status: this.getStatus(business.status),
      createdAt: DateUtils.formatISODate(business.createdAt),
      fidel: this.getFidel(business.fidelStatus),
      shouldHideForCustomer: business.shouldHideForCustomer,
      hasCoverCap: business.coverCap && business.coverCap.id,
      coverCap: business.coverCap,
    }));
  }

  openBusinessDetail(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'adminBusinessDetails',
      data: event,
      width: '750px',
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  getCoverCapBackground(business: any) {
    if (!business.coverCap.id) {
      return {};
    }
    return {
      backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 1) 150px), url('${
        business.coverCap.publicPath.small
      }')`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right',
    };
  }

  uploadCoverCap(business: any) {
    const target = (this.$refs[`fileInput-${business.id}`] as Element[])[0];
    if (target && (target as HTMLInputElement).click) {
      (target as HTMLInputElement).click();
    }
  }

  async handleCoverCapUpload(event: any) {
    event.preventDefault();
    try {
      this.$showLoaderWithLocker();
      const file = event.target.files[0];
      const formData = new FormData();
      const businessId = event.target.getAttribute('data-businessid');
      if (!file) {
        this.$notification('File not selected');
        return;
      }
      formData.append('coverCap', file);
      await this.imageUploadService
        .uploadCoverCapImage(businessId, formData)
        .then((res) => {
          const business = this.businessList.list.find(
            ({ id }) => id == businessId,
          );
          business.coverCap = {
            id: res.data.id,
            publicPath: res.data.publicPath,
          };
        });
    } finally {
      this.$hideLoader();
    }
  }
}
